export const ADD_STORY_TOOLTIP = {
  url: 'https://docs.haptik.ai/essentials/all-about-skill-set',
  text:
    'A Story is like a folder on your computer, which contains all tasks required to build your bot.',
};

export const GENERAL_NODES_TOOLTIP = {
  url: 'https://docs.haptik.ai/essentials/how-to-configure-faq-section',
  text:
    'FAQ Steps are checked irrespective of the bot’s context and are ideal for FAQs',
};

export const SMALLTALK_TOOLTIP = {
  url: null,
  text:
    'Smalltalk allows the bot to handle miscellaneous and out of context user responses',
};

// Unused. But maybe needed in the new LHS
export const ADD_SUB_STORY_TOOLTIP = {
  url: 'https://docs.haptik.ai/essentials/all-about-skill-set',
  text: 'Organize your conversational flow into Skill and add them here',
};

export const EDIT_SUB_STORY_TOOLTIP = {
  url: null,
  text: 'Edit sub Skill Set',
};

export const ADD_NODE_TOOLTIP = {
  url: 'https://docs.haptik.ai/bot-builder/basic/creating-nodes',
  text: 'A Step is the building block of the conversation your bot will have',
};

export const NODE_API_INTEGRATIONS_TOOLTIP = {
  url: 'https://docs.haptik.ai/bot-builder/advanced/integrating-custom-code',
  text: 'Integrate an API into this Step',
};

export const NODE_BOT_SAYS_TOOLTIP = {
  url: 'https://docs.haptik.ai/bot-builder/basic/bot-says',
  text: 'Define the bot response for this Step',
};

export const NODE_BOT_SAYS_FINAL_RESPONSE_TOOLTIP = {
  url: null,
  text:
    'Final response message is what you send the user after mandatory entities have been collected on this Step',
};

export const NODE_BOT_SAYS_DEFAULT_RESPONSE_TOOLTIP = {
  url: null,
  text:
    'Write what bot will respond to the user. <br/> ' +
    '(For multiple entities, consider this as a opening message. Eg: Please provide me the following details)',
};

export const NODE_BOT_SAYS_FILTER_TOOLTIP = {
  url: null,
  text:
    'Add filter values to shortlist this Step for this entity.<br/><br/>' +
    'Eg: If you want to shortlist this Step from a list of Steps only when entity value is Mumbai, ' +
    'then add Mumbai as a filter value for this entity.',
};

export const NODE_BOT_SAYS_EDIT_ENTITY_TOOLTIP = {
  url: null,
  text: 'Edit Entity, values and variants:',
};

export const NODE_BOT_SAYS_REMOVE_ENTITY_TOOLTIP = {
  url: null,
  text: 'Remove this entity from bot responses',
};

export const NODE_BOT_SAYS_REORDER_ENTITY_TOOLTIP = {
  url: null,
  text:
    'Rearrange this entity. <br/>' +
    'Sequence of entities decide the order in which bot will collect values for these entities',
};

export const NODE_BOT_SAYS_SECTION_EXPAND_TOOLTIP = {
  url: null,
  text:
    'Expand this to add/edit what bot will respond to collect information(entity value) for this entity',
};

export const NODE_BOT_SAYS_SECTION_COLLAPSE_TOOLTIP = {
  url: null,
  text: 'Collapse',
};

export const NODE_BOT_SAYS_ENTITY_DEPRECATED_TOOLTIP = {
  url: null,
  text:
    'This entity has been deprecated. To add it to your Step, follow these simple Steps: <br>' +
    '1. Click "Edit Entity" icon<br>' +
    '2. Click "Copy Entity" button on top right<br>' +
    '3. Rename your new entity and Save<br>' +
    '4. Click on "Add To Bot Responses" button',
};

export const NODE_CONFIGURATION_TOOLTIP = {
  url:
    'https://docs.haptik.ai/bot-builder/basic/creating-nodes#creating-a-node',
  text: 'Edit Step settings',
};

export const NODE_CONNECTIONS_TOOLTIP = {
  url: 'https://docs.haptik.ai/bot-builder/basic/connections',
  text: 'Set how the user transitions from the previous Step to this Step',
};

export const NODE_ENITIES_TOOLTIP = {
  url: 'https://docs.haptik.ai/entities/what-are-entities',
  text:
    'An entity represents a specific set of inputs that a user is prompted to enter.',
};

export const NODE_USER_SAYS_TOOLTIP = {
  url: 'https://docs.haptik.ai/bot-builder/basic/user-says',
  text: 'Define the user intent for this Step',
};

export const GRAPH_SHOW_INACTIVE_NODES_TOOLTIP = {
  url: null,
  text: 'Show inactive Steps',
};

export const GRAPH_HIDE_INACTIVE_NODES_TOOLTIP = {
  url: null,
  text: 'Hide inactive Steps',
};

export const USER_SAYS_SYNONYMS_TOOLTIP = {
  url: null,
  text:
    'You can now add and enable multiple synonyms for a particular word. ' +
    'Double click/drag to select the word & enable synonyms or tags.',
};

export const USER_SAYS_SYNONYMS_BLACK_UNDERLINE = {
  url: null,
  text:
    'Black Underline signifies that the system has detected synonyms ' +
    'for this word. Select the word to enable synonyms.',
};

export const USER_SAYS_SYNONYMS_BLUE_UNDERLINE = {
  url: null,
  text: 'Blue underline signifies that synonyms are enabled for this word.',
};

export const USER_SAYS_SYNONYMS_YELLOW_UNDERLINE = {
  url: null,
  text: 'Yellow tag signifies that gogo will give priority to these words.',
};

export const USER_SAYS_TITLE_TOOLTIP = {
  url: 'https://docs.haptik.ai/bot-builder/basic/user-says',
  text:
    'Define the user inputs that will prompt this Step to bring users from their ' +
    'previous location in the conversation to this Step',
};

export const BOT_SAYS_TITLE_TOOLTIP = {
  url: 'https://docs.haptik.ai/bot-builder/basic/bot-says',
  text:
    'Define how the bot will reply to the user intent captured in this Step',
};

export const BOT_SAYS_ADD_VARIANT_TOOLTIP = {
  url: null,
  text:
    'Bots rotate randomly through the variants you define here to avoid becoming repetitive.',
};

export const BOT_SAYS_DELETE_CHAT_BUBBLE = {
  url: null,
  text: 'Delete this message',
};

export const BOT_SAYS_ENTITY_RESPONSE = {
  url: null,
  text:
    'Add the bot responses that will prompt users to give inputs relevant to this entity.',
};

export const NODE_CONNECTIONS_ADD_NEW_TOOLTIP = {
  url: 'https://docs.haptik.ai/bot-builder/basic/connections',
  text: 'Create new connections to move from 1 Step to another',
};

export const NODE_CONNECTIONS_DELETE_TOOLTIP = {
  url: null,
  text: 'Delete Connections',
};

export const NODE_API_RESPONSES_API_KEY = {
  url:
    'https://docs.haptik.ai/bot-builder/advanced/integrating-custom-code#webhooks',
  text: 'Code that will identify Haptik as caller of this API',
};

export const NODE_API_RESPONSES_API_URL = {
  url:
    'https://docs.haptik.ai/bot-builder/advanced/integrating-custom-code#webhooks',
  text: 'API URL that returns a valid response',
};

export const NODE_API_RESPONSES_AFTER_RESPONSE = {
  url: null,
  text: 'Write what bot will respond to the user after the function.',
};

export const NODE_API_RESPONSES_BEFORE_RESPONSE = {
  url: null,
  text: 'Write what bot will respond to the user before the function.',
};

export const NODE_API_RESPONSES_ENTITY_FUNCTION_TOOLTIP = {
  url:
    'https://docs.haptik.ai/bot-builder/advanced/integrating-custom-code#api-functions',
  text: 'Enter the Entity function name',
};

export const NODE_API_RESPONSES_INTEGRATON_FUNCTION_TOOLTIP = {
  url:
    'https://docs.haptik.ai/bot-builder/advanced/integrating-custom-code#api-functions',
  text: 'Enter the Integration function name',
};

export const PARTNER_RESPONSES_OVERLAY_TITLE_TOOLTIP = {
  url: 'https://docs.haptik.ai/bot-builder/advanced/integrating-custom-code',
  text: 'Integrate custom code on this Step',
};

export const CREATE_BOT_BUSINESS_TOOLTIP = {
  url: null,
  text: 'Select a Business where this Bot can be added or create a new one.',
};

export const CREATE_BOT_PARTNER_TOOLTIP = {
  url: null,
  text: 'Select a Partner which should own this Bot or create a new one.',
};

export const CREATE_BOT_NAME_TOOLTIP = {
  url: null,
  text: 'Bot name is a unique identifier for your Bot',
};

export const CREATE_TEMPLATE_NAME_TOOLTIP = {
  url: null,
  text: 'Name which will be used to identify this Smart Skill',
};

export const CREATE_TEMPLATE_DESCRIPTION_TOOLTIP = {
  url: null,
  text:
    'Describe this Smart Skill to make it easier for Users to use your Smart Skill',
};

export const CREATE_TEMPLATE_TASK_MSG_TOOLTIP = {
  url: null,
  text: 'Specify the message to show in the menu when Users test your Smart Skill',
};

export const BOT_SAYS_NON_FINAL_API_WARNING = {
  text:
    "Do not use '{}' in the middle of a reply. This is an anti-pattern. " +
    'Build a different Step with a different integration function for modularity.',
};

export const NEW_SUBSTORY_TOOLTIP = {
  url: 'https://docs.haptik.ai/essentials/all-about-skill-set',
  text: 'Skills are smaller tasks that together make up your Skill Set',
};

export const NEW_NODE_TOOLTIP = {
  url: 'https://docs.haptik.ai/bot-builder/basic/creating-nodes#what-is-a-node',
  text:
    'A Step is a task within your Skill that answers specific user intent(s) for your bot.',
};

export const STATIC_NODE_TOOLTIP = {
  url:
    'https://docs.haptik.ai/bot-builder/basic/creating-nodes#different-types-of-nodes',
  text:
    'You can use a Static Step to present static information to the user like greeting message, menu options etc and to collect infromation from the user that is required to perform business logic.',
};

export const CODE_NODE_TOOLTIP = {
  url:
    'https://docs.haptik.ai/bot-builder/basic/creating-nodes#different-types-of-nodes',
  text:
    'You can use a Code Step to take the input collected from the Static Step and use custom code to perfrom business logic on it.',
};

export const OUTPUT_NODE_TOOLTIP = {
  url:
    'https://docs.haptik.ai/bot-builder/basic/creating-nodes#different-types-of-nodes',
  text:
    'You can use the Output Step to take the JSON output from the Code Step and build dynamic bot responses that use parameters from this output in the HSL.',
};

export const NEW_SUBSTORY_YELLOW_TOOLTIP = {
  url: 'https://docs.haptik.ai/essentials/all-about-skill-set',
  text: 'Click on New skill to start building your bot.',
};

export const NEW_NODE_YELLOW_TOOLTIP = {
  url:
    'https://docs.haptik.ai/bot-builder/basic/creating-nodes#creating-a-node',
  text:
    "Your skill is created. Let's click on Add Steps to create your first Step.",
};

export const NEW_NODE_TYPE_YELLOW_TOOLTIP = {
  url: 'https://docs.haptik.ai/bot-builder/basic/creating-nodes#what-is-a-node',
  text: 'You can choose a Step type to achieve your bot functionality.',
};

export const LOCAL_ENTITY_TOOLTIP = {
  url: 'https://docs.haptik.ai/entities/what-are-entities',
  text:
    'Before you create a new entity, we recommend you search from the existing entities.',
};

export const DISAMBIGUATION_TOOLTIP = {
  url: 'https://docs.haptik.ai/nlu/what-is-bot-disambiguation',
  text:
    'The button text is shown to the user when the bot is not confident and needs the user to select a Step from a set of options.',
};
